import { gql } from '@apollo/client'

export default gql(`
query($id: ID!) {
    getOptaSyncState(id: $id) {
        id
        title
        frequency
        lastRunTime
        opId
        isRunning
        isActive
        isError,
        isNonOpta,
        baseUrl,
        source,
        enableFasterSync
    }    
}`)
